import React from 'react';

export default function BranchSelectorMap({ children }) {
  const style = {
    backgroundColor: '#9acde5',
    display: 'block',
    width: 740,
    height: 420,
    borderRadius: 6,
    margin: '0 auto',
    position: 'relative',
  };

  return <div style={style}>{children}</div>;
}

BranchSelectorMap.displayName = 'BranchSelectorMap';
